import {ImplementationActivityFeeResponse, ImplementationYearlyFee} from '@frontend/shared';
import {ModuleData} from '../module-data';
import {DirectusTranslation} from '@frontend/directus';

export interface ImplementationFeesContainer extends ModuleData {
  data: Array<ImplementationActivityFeeResponse>;
}

export enum RowType {
  PARENT = 'PARENT',
  CHILD = 'CHILD',
  SUM = 'SUM',
}

export interface FeeRowVM {
  groupId: number;
  isVisible: boolean;
  rowType: RowType;
  implementationContainerDirectus: DirectusTranslation[];
  hourlyRate: number | null;
  yearlyFees: Array<ImplementationYearlyFee>;
  totalAcrossScope: number;
  comment?: string;
  formGroupIndex?: number;
  childIndex?: number;
}
